var set = require('regenerate')(0x3030, 0x3037, 0x30FB);

set.addRange(0x2EA, 0x2EB).addRange(0x3001, 0x3003).addRange(0x3008, 0x3011).addRange(0x3013, 0x301F).addRange(0x302A, 0x302D).addRange(0x3105, 0x312F).addRange(0x31A0, 0x31BA).addRange(0xFE45, 0xFE46).addRange(0xFF61, 0xFF65);
module.exports = set;